function useMiddleware() {
	window.open('*', '_self');
}

export default {
	useMiddleware
};
